const legacyBasePath = "/backoffice";

export const BACKOFFICE_BASE_PATH = (
  window.location.pathname === legacyBasePath
  || window.location.pathname.startsWith(`${legacyBasePath}/`)
)
  ? legacyBasePath
  : "";

export function backofficePath(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${BACKOFFICE_BASE_PATH}${normalized}`;
}
